import { render } from "./inventoryreport.vue?vue&type=template&id=536e2b5c&scoped=true"
import script from "./inventoryreport.vue?vue&type=script&lang=js"
export * from "./inventoryreport.vue?vue&type=script&lang=js"

import "./report-theme.css?vue&type=style&index=0&id=536e2b5c&scoped=true&lang=css"
import "./inventoryreport.vue?vue&type=style&index=1&id=536e2b5c&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536e2b5c"]])

export default __exports__